/***** SCRIPTS POUR GERER LES BLOCS DU BUILDER *****/

    $('document').ready(setupBlocks);

    function setupBlocks() {
        initSlickSlider();
        initBlockMedia();
        initBlockPartners();
        initTabBlock();
        initSideTabBlock();
        initBlockTrombinoscope();
        initNewsBlock();
    }

    // Fonction pour initialiser les sliders avec Slick
    function initSlickSlider() {
        //Slider du Bloc Slider
        $('.blockslider-slides').slick({
            dots: false,
            arrows: true,
            infinite: true,
            speed: 600,
            fade: false,
            autoplay: true,
            autoplaySpeed: 5000,
            pauseOnHover: true,
            adaptiveHeight: true,
            slidesToShow: 1,
            cssEase: 'ease-in-out'
        });

        //Slider du Bloc Témoignage simple
        $('.blocktestimonysimple-slide').each(function() {
            let textSlider = $(this).find('.blocktestimonysimple-slidetext');
            let imgSlider = $(this).find('.blocktestimonysimple-imgcontainer');
            imgSlider.slick({
                dots: false,
                arrows: false,
                infinite: false,
                speed: 600,
                fade: true,
                adaptiveHeight: false,
                slidesToShow: 1,
                asNavFor: textSlider
            });
            textSlider.slick({
                dots: false,
                arrows: true,
                infinite: false,
                speed: 600,
                fade: false,
                adaptiveHeight: false,
                slidesToShow: 1,
                dotsClass: 'slick-dots',
                prevArrow: '<button aria-label="Aller à la slide précédente" type="button" class="slick-prev icon-prev"><svg><use xlink:href="' + siteUrl + '/app/themes/wp_theme/images/sprites.svg#icone-arrow"></use></svg></button>',
                nextArrow: '<button aria-label="Aller à la prochaine slide" type="button" class="slick-next icon-prev"><svg><use xlink:href="' + siteUrl + '/app/themes/wp_theme/images/sprites.svg#icone-arrow"></use></svg></button>',
                appendArrows: $(this).find('.slicknav'),
                asNavFor: imgSlider
            });
        });

        // Slider du bloc découvrir aussi
        $('.blockdiscover-slide').each(function() {
            let textSlider = $(this).find('.blockdiscover-textcontainer');
            let imgSlider = $(this).find('.blockdiscover-img');
            imgSlider.slick({
                dots: false,
                arrows: false,
                infinite: false,
                speed: 600,
                fade: true,
                adaptiveHeight: false,
                slidesToShow: 1,
                asNavFor: textSlider
            });
            textSlider.slick({
                dots: false,
                arrows: true,
                infinite: false,
                speed: 600,
                fade: false,
                adaptiveHeight: false,
                slidesToShow: 1,
                dotsClass: 'slick-dots',
                prevArrow: '<button aria-label="Aller à la slide précédente" type="button" class="slick-prev icon-prev"><svg><use xlink:href="' + siteUrl + '/app/themes/wp_theme/images/sprites.svg#icone-arrow"></use></svg></button>',
                nextArrow: '<button aria-label="Aller à la prochaine slide" type="button" class="slick-next icon-prev"><svg><use xlink:href="' + siteUrl + '/app/themes/wp_theme/images/sprites.svg#icone-arrow"></use></svg></button>',
                appendArrows: $(this).find('.slicknav'),
                asNavFor: imgSlider,
                responsive: [
                    {
                        breakpoint: 760,
                        settings: {
                            adaptiveHeight: true
                        }
                    }
                ]
            });
        });

        //Slider du Bloc Numbers
        $('.blocksnumbers-slides').slick({
            dots: false,
            arrows: true,
            speed: 400,
            fade: false,
            autoplaySpeed: 5000,
            pauseOnHover: true,
            slidesToShow: 4,
            slidesToScroll: 2,
            infinite: false,
            autoplay: false,
            cssEase: 'ease-in-out',
            prevArrow: '<button type="button" aria-label="Aller à la slide précédente" class="slick-prev icon-prev"><svg class="icon"><use xlink:href="' + siteUrl + '/app/themes/wp_theme/images/sprites.svg#icone-arrow"></use></svg></button>',
            nextArrow: '<button type="button" aria-label="Aller à la prochaine slide" class="slick-next icon-next"><svg class="icon"><use xlink:href="' + siteUrl + '/app/themes/wp_theme/images/sprites.svg#icone-arrow"></use></svg></button>',
            appendArrows: $('.blocksnumbers-wrapper').children('.slicknav'),
            responsive: [
                {
                    breakpoint: 1000,
                    settings: {
                        autoplay: false,
                        slidesToShow: 3,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 760,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 576,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                },
            ]
        });

        //Slider du Bloc Galerie
        let blockgalerie = [];
        $('.blockgalerie').each(function(index) {
            let bloc = $(this);
            let settingsblockgalerie = {
                infinite: false,
                arrows: true,
                dots: false,
                adaptiveHeight: false,
                variableWidth: true,
                autoplay: false,
                autoplaySpeed: 5000,
                speed: 500,
                slidesToShow: 2,
                slidesToScroll: 1,
                prevArrow: '<button aria-label="Aller à la slide précédente" type="button" class="slick-prev icon-prev"><svg class="icon"><use xlink:href="' + siteUrl + '/app/themes/wp_theme/images/sprites.svg#icone-arrow"></use></svg></button>',
                nextArrow: '<button aria-label="Aller à la prochaine slide" type="button" class="slick-next icon-prev"><svg class="icon"><use xlink:href="' + siteUrl + '/app/themes/wp_theme/images/sprites.svg#icone-arrow"></use></svg></button>',
                appendArrows: bloc.find('.slicknav'),
                dotsClass: 'slick-dots whiteDots',
                responsive: [
                    {
                        breakpoint: 1000,
                        settings: {
                            slidesToShow: 2,
                            autoplay: false
                        }
                    },
                    {
                        breakpoint: 760,
                        settings: {
                            slidesToShow: 1
                        }
                    }
                ]
            };
            blockgalerie[index] = bloc.find('.blockgalerie-slides').slick(settingsblockgalerie);
            if( $(window).width() < 1000 && !blockgalerie[index].hasClass('slick-initialized')) bloc.find('.blockgalerie-slides').slick(settingsblockgalerie);
            $(window).on('resize', function() {
                if( $(window).width() < 1000 && !blockgalerie[index].hasClass('slick-initialized')) bloc.find('.blockgalerie-slides').slick(settingsblockgalerie);
            });
        });

        // Bloc partenaires
        $('.blockpartners').each(function() {
            let bloc = $(this);
            bloc.find('.blockpartners-logos').slick({
                infinite: false,
                arrows: true,
                dots: true,
                adaptiveHeight: false,
                variableWidth: false,
                autoplay: false,
                speed: 600,
                slidesToShow: 4,
                slidesToScroll: 1,
                prevArrow: '<button aria-label="Aller à la slide précédente" type="button" class="slick-prev icon-prev"><svg><use xlink:href="' + siteUrl + '/app/themes/wp_theme/images/sprites.svg#icone-arrow"></use></svg></button>',
                nextArrow: '<button aria-label="Aller à la prochaine slide" type="button" class="slick-next icon-prev"><svg><use xlink:href="' + siteUrl + '/app/themes/wp_theme/images/sprites.svg#icone-arrow"></use></svg></button>',
                appendArrows: bloc.children('.slicknav'),
                dotsClass: 'slick-dots whiteDots',
                responsive: [
                    {
                        breakpoint: 1000,
                        settings: {
                            slidesToShow: 3,
                            autoplay: false,
                            infinite: true
                        }
                    },
                    {
                        breakpoint: 760,
                        settings: {
                            slidesToShow: 2
                        }
                    },
                    {
                        breakpoint: 576,
                        settings: {
                            slidesToShow: 1
                        }
                    }
                ]
            });
        });

        // Bloc alternanceimgtext
        let blockalternanceimgtext = [];
        $('.blockalternance').each(function(index) {
            let bloc = $(this);
            let settingsblockalternanceimgtext = {
                infinite: false,
                arrows: true,
                dots: true,
                adaptiveHeight: false,
                variableWidth: false,
                autoplay: false,
                autoplaySpeed: 5000,
                speed: 600,
                slidesToShow: 1,
                slidesToScroll: 1,
                prevArrow: '<button aria-label="Aller à la slide précédente" type="button" class="slick-prev icon-prev"><svg><use xlink:href="' + siteUrl + '/app/themes/wp_theme/images/sprites.svg#icone-arrow"></use></svg></button>',
                nextArrow: '<button aria-label="Aller à la prochaine slide" type="button" class="slick-next icon-prev"><svg><use xlink:href="' + siteUrl + '/app/themes/wp_theme/images/sprites.svg#icone-arrow"></use></svg></button>',
                appendArrows: bloc.children('.slicknav'),
                dotsClass: 'slick-dots whiteDots',
                responsive: [
                    {
                        breakpoint: 5000,
                        settings: "unslick"
                    },
                    {
                        breakpoint: 1000,
                        settings: {
                            slidesToShow: 1,
                            infinite: false,
                            autoplay: false,
                        }
                    }
                ]
            };
            blockalternanceimgtext[index] = bloc.find('.blockalternance-slider').slick(settingsblockalternanceimgtext);
            if( $(window).width() < 1000 && !blockalternanceimgtext[index].hasClass('slick-initialized')) bloc.find('.blockalternance-slider').slick(settingsblockalternanceimgtext);
            $(window).on('resize', function() {
                if( $(window).width() < 1000 && !blockalternanceimgtext[index].hasClass('slick-initialized')) bloc.find('.blockalternance-slider').slick(settingsblockalternanceimgtext);
            });
        });

        //Block colors
        var blockColorsSlick = [];
        $('.blockcolors-wrapper').each(function(index) {
            let bloc = $(this);
            let settingsBlockColors = {
                infinite: false,
                arrows: true,
                dots: false,
                adaptiveHeight: false,
                variableWidth: true,
                autoplay: false,
                speed: 600,
                slidesToShow: 1,
                slidesToScroll: 1,
                prevArrow: '<button aria-label="Aller à la slide précédente" type="button" class="slick-prev icon-prev"><svg><use xlink:href="' + siteUrl + '/app/themes/wp_theme/images/sprites.svg#icone-arrow"></use></svg></button>',
                nextArrow: '<button aria-label="Aller à la prochaine slide" type="button" class="slick-next icon-prev"><svg><use xlink:href="' + siteUrl + '/app/themes/wp_theme/images/sprites.svg#icone-arrow"></use></svg></button>',
                appendArrows: bloc.children('.slicknav'),
                dotsClass: 'slick-dots whiteDots',
                responsive: [
                    {
                        breakpoint: 5000,
                        settings: "unslick"
                    },
                    {
                        breakpoint: 1200,
                        settings: {
                            slidesToShow: 2
                        }
                    },
                    {
                        breakpoint: 760,
                        settings: {
                            slidesToShow: 1
                        }
                    }
                ]
            };
            blockColorsSlick[index] = bloc.children('.blockcolors-items').slick(settingsBlockColors);
            $(window).on('resize', function () {
                if ($(window).width() < 1200 && !blockColorsSlick[index].hasClass('slick-initialized')) bloc.children('.blockcolors-items').slick(settingsBlockColors);
            });
        });

        //Block timeline
        $('.blocktimeline').each(function() {
            $(this).children().children('.blocktimeline-timeline').slick({
                dots: false,
                arrows: true,
                infinite: false,
                speed: 600,
                fade: false,
                autoplay: false,
                slidesToShow: 2,
                slideToScroll: 1,
                variableWidth: true,
                adaptiveHeight: true,
                prevArrow: '<button aria-label="Aller à la slide précédente" type="button" class="slick-prev icon-prev"><svg><use xlink:href="' + siteUrl + '/app/themes/wp_theme/images/sprites.svg#icone-arrow"></use></svg></button>',
                nextArrow: '<button aria-label="Aller à la prochaine slide" type="button" class="slick-next icon-prev"><svg><use xlink:href="' + siteUrl + '/app/themes/wp_theme/images/sprites.svg#icone-arrow"></use></svg></button>',
                appendArrows: $(this).children().children('.slicknav'),
                responsive: [
                    {
                        breakpoint: 5000,
                        settings: {
                            slidesToShow: 2,
                            slideToScroll: 1
                        }
                    },
                    {
                        breakpoint: 1000,
                        settings: {
                            slidesToShow: 2,
                            slideToScroll: 1
                        }
                    },
                    {
                        breakpoint: 576,
                        settings: {
                            slidesToShow: 1,
                            slideToScroll: 1,
                            variableWidth: false,
                        }
                    }
                ]

            });
        });

        //Block accompagnement
        let blockaccompagnement = [];
        $('.blockaccompagnement').each(function(index) {
            let bloc = $(this);
            let settingsblockaccompagnement = {
                infinite: true,
                arrows: true,
                dots: false,
                adaptiveHeight: false,
                variableWidth: true,
                autoplay: false,
                initialSlide: $(this).find('.focus').index(),
                autoplaySpeed: 5000,
                speed: 600,
                slidesToShow: 1,
                slidesToScroll: 1,
                prevArrow: '<button aria-label="Aller à la slide précédente" type="button" class="slick-prev icon-prev"><svg><use xlink:href="' + siteUrl + '/app/themes/wp_theme/images/sprites.svg#icone-arrow"></use></svg></button>',
                nextArrow: '<button aria-label="Aller à la prochaine slide" type="button" class="slick-next icon-prev"><svg><use xlink:href="' + siteUrl + '/app/themes/wp_theme/images/sprites.svg#icone-arrow"></use></svg></button>',
                appendArrows: bloc.find('.slicknav'),
                dotsClass: 'slick-dots whiteDots',
                responsive: [
                    {
                        breakpoint: 5000,
                        settings: "unslick"
                    },
                    {
                        breakpoint: 1000,
                        settings: {
                            slidesToShow: 2,
                            infinite: true,
                            autoplay: false,
                        }
                    },
                    {
                        breakpoint: 760,
                        settings: {
                            slidesToShow: 1,
                            infinite: true,
                            autoplay: false,
                        }
                    }
                ]
            };
            blockaccompagnement[index] = bloc.find('.blockaccompagnement-items').slick(settingsblockaccompagnement);
            if( $(window).width() < 1000 && !blockaccompagnement[index].hasClass('slick-initialized')){
                bloc.find('.blockaccompagnement-items').slick(settingsblockaccompagnement);
                destoyMasonry();
            }else if($(window).width() > 1000 && !blockaccompagnement[index].hasClass('slick-initialized')){
                initMasonry();
            }

            $(window).on('resize', function() {
                if( $(window).width() < 1000 && !blockaccompagnement[index].hasClass('slick-initialized')){
                    bloc.find('.blockaccompagnement-items').slick(settingsblockaccompagnement);
                    destoyMasonry();
                }else if($(window).width() > 1000 && !blockaccompagnement[index].hasClass('slick-initialized')){
                    initMasonry();
                }
            });
        });

        //Block accompagnement
        let blockaccompagnementslider = [];
        $('.blockaccompagnementslider-wrapper').each(function(index) {
            let bloc = $(this);
            let settingsblockaccompagnementslider = {
                infinite: false,
                arrows: true,
                dots: false,
                adaptiveHeight: false,
                variableWidth: true,
                autoplay: false,
                autoplaySpeed: 5000,
                speed: 600,
                slidesToShow: 2,
                slidesToScroll: 1,
                prevArrow: '<button aria-label="Aller à la slide précédente" type="button" class="slick-prev icon-prev"><svg><use xlink:href="' + siteUrl + '/app/themes/wp_theme/images/sprites.svg#icone-arrow"></use></svg></button>',
                nextArrow: '<button aria-label="Aller à la prochaine slide" type="button" class="slick-next icon-prev"><svg><use xlink:href="' + siteUrl + '/app/themes/wp_theme/images/sprites.svg#icone-arrow"></use></svg></button>',
                appendArrows: bloc.find('.slicknav'),
                dotsClass: 'slick-dots whiteDots',
                responsive: [
                    {
                        breakpoint: 5000,
                        settings: {
                            variableWidth: true,
                            slidesToShow: 2,
                        }
                    },
                    {
                        breakpoint: 1360,
                        settings: {
                            slidesToShow: 1,
                            variableWidth: true,
                        }
                    },
                    {
                        breakpoint: 760,
                        settings: {
                            slidesToShow: 1,
                            variableWidth: false,
                        }
                    },
                ]

            };
            if (bloc.find('.blockaccompagnementslider-items').children().length > 1) {
                bloc.find('.blockaccompagnementslider-items').slick(settingsblockaccompagnementslider);
            }
        });
    }

    // Fonction qui permet de lire une vidéo
    function initBlockMedia() {
        $('.blocktextimg-media.has-video, .blockmedia-media.has-video, .headerhome-media.has-video').click(function() {
            if(!$(this).hasClass('showVideo')){
                $(this).addClass('showVideo');
                $(this).find('iframe')[0].src += "&autoplay=1";
            }
        });
    }

    //permet le fonctionnement du block partenaire
    function initBlockPartners() {
        $('.blockpartners-categories-trigger').click(function() {
            let category = $(this).attr('data-cat');

            //activation class des catégories
            $('.blockpartners-categories-trigger').removeClass('active');
            $(this).addClass('active');

            //activation class des partenaires
            $('.blockpartners-logos').removeClass('active');
            $('#blockpartners-'+category).addClass('active');
        });
    }

    function initTabBlock() {
        $('.blocktabs').each(function () {
            var block = $(this);
            block.children('.blocktabs-container').css('min-height', $(this).children('.blocktabs-container').children('.tab:first-child').height() + 'px');

            block.find('.blocktabs-tabs li').click(function () {
                if ($(this).hasClass('current') && $(window).width() < 1000) {
                    if ($(this).parent().hasClass('open')) {
                        $(this).parent().removeClass('open');
                        $(this).parent().children('li:not(.current)').slideUp(200);
                    } else {
                        $(this).parent().addClass('open');
                        $(this).parent().children('li:not(.current)').slideDown(200);
                    }
                }
                if (!$(this).hasClass('current')) {
                    var tabId = $(this).attr('id').split('tab-');
                    block.find('.blocktabs-tabs').children('.current').removeClass('current');
                    $(this).addClass('current');
                    block.find('.blocktabs-container').children('.current').removeClass('current');
                    if ($(window).width() < 1000) {
                        $(this).parent().removeClass('open');
                        $(this).parent().children('li:not(.current)').slideUp(200);
                    }
                    setTimeout(function () {
                        block.find('#tab-content-' + tabId[1]).addClass('current');
                        block.children('.blocktabs-container').css('min-height', block.find('#tab-content-' + tabId[1]).innerHeight() + 'px');
                    }, 200);
                }
            });

            $(window).resize(function () {
                block.children('.blocktabs-container').css('min-height', block.children('.blocktabs-container').children('.tab.current').innerHeight() + 'px');
            });
        });
    }

    function initSideTabBlock() {
        $('.blocksidetabs').each(function () {
            var block = $(this);
            block.children('.blocksidetabs-container').css('min-height', $(this).children('.blocksidetabs-container').children('.tab:first-child').height() + 'px');

            block.find('.blocksidetabs-tabs li').click(function () {
                if ($(this).hasClass('current') && $(window).width() < 1000) {
                    if ($(this).parent().hasClass('open')) {
                        $(this).parent().removeClass('open');
                        $(this).parent().children('li:not(.current)').slideUp(200);
                    } else {
                        $(this).parent().addClass('open');
                        $(this).parent().children('li:not(.current)').slideDown(200);
                    }
                }
                if (!$(this).hasClass('current')) {
                    var tabId = $(this).attr('id').split('tab-');
                    block.find('.blocksidetabs-tabs').children('.current').removeClass('current');
                    $(this).addClass('current');
                    block.find('.blocksidetabs-container').children('.current').removeClass('current');
                    if ($(window).width() < 1000) {
                        $(this).parent().removeClass('open');
                        $(this).parent().children('li:not(.current)').slideUp(200);
                    }
                    setTimeout(function () {
                        block.find('#tab-content-' + tabId[1]).addClass('current');
                        block.children('.blocksidetabs-container').css('min-height', block.find('#tab-content-' + tabId[1]).innerHeight() + 'px');
                    }, 200);
                }
            });

            $(window).resize(function () {
                block.children('.blocksidetabs-container').css('min-height', block.children('.blocksidetabs-container').children('.tab.current').innerHeight() + 'px');
            });
        });
    }

    function initBlockTrombinoscope() {
        $("#more_posts").on("click", function (e) { // When btn is pressed.
            e.preventDefault();
            load_posts();
        });
        if(new URLSearchParams(document.location.search.substring(1)).get('pole') !== null){
            $('html, body').animate({
                scrollTop: $("#form-trombi").offset().top - 200
            }, 0);
        }
    }

    function initNewsBlock() {
        $('.blocknews-grid, .newspage').masonry({ horizontalOrder: true });
        $('.blocknewslider').each(function() {
            $(this).children('.blocknewslider-grid').slick({
                dots: false,
                arrows: true,
                infinite: false,
                speed: 600,
                fade: false,
                autoplay: false,
                slidesToShow: 4,
                slideToScroll: 2,
                variableWidth: true,
                adaptiveHeight: false,
                prevArrow: '<button type="button" class="slick-prev">Précédent</button>',
                nextArrow: '<button type="button" class="slick-next">Suivant</button>',
                appendArrows: $(this).children('.slicknav'),
                responsive: [
                    {
                        breakpoint: 5000,
                        settings: {
                            slidesToShow: 4,
                            slideToScroll: 2
                        }
                    },
                    {
                        breakpoint: 1550,
                        settings: {
                            slidesToShow: 3,
                            slideToScroll: 2
                        }
                    },
                    {
                        breakpoint: 1200,
                        settings: {
                            slidesToShow: 3,
                            slideToScroll: 1
                        }
                    },
                    {
                        breakpoint: 1000,
                        settings: {
                            slidesToShow: 2,
                            slideToScroll: 1
                        }
                    },
                    {
                        breakpoint: 576,
                        settings: {
                            slidesToShow: 1,
                            slideToScroll: 1
                        }
                    }
                ]
            });
        });
    }

    function initMasonry() {
        let masonryOptions = {
            itemSelector: '.blockaccompagnement-item',
        }

        if(!isMasonryEnabled){
            $('.blockaccompagnement-items').masonry( masonryOptions );
        }

        isMasonryEnabled = true;
    }

    function destoyMasonry() {
        if(isMasonryEnabled){
            $('.blockaccompagnement-items').masonry('destroy');
        }
        isMasonryEnabled = false;
    }